const ChannelTypes = {
  SITE: 'site',
  MOBILE_PATROL: 'mobile_patrol',
  BRANCH: 'branch',
};

const MessageTypes = {
  USER: 'user',
  ACTIVITY: 'activity',
};

const PaginationDirection = {
  INITIAL: 'initial',
  BEFORE: 'before',
  AFTER: 'after',
};

export {
  ChannelTypes,
  MessageTypes,
  PaginationDirection,
};
